import { ConfirmDialog } from "@/components/ui/ConfirmDialog";

interface BlockingConditionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  overlayDataTestId?: string;
  closeButtonDataTestId?: string;
  okButtonDataTestId?: string;
}

export function BlockingConditionsModal({
  isOpen,
  onClose,
  overlayDataTestId,
  closeButtonDataTestId,
  okButtonDataTestId,
}: BlockingConditionsModalProps) {
  return (
    <ConfirmDialog
      isOpen={isOpen}
      title="Unable to Process"
      message="Please direct applicant to Liberty Rent when these conditions are agreed to by the Property."
      primaryLabel="Ok"
      secondaryLabel=""
      primaryFirst
      presentation="saveChanges"
      overlayDataTestId={overlayDataTestId}
      primaryButtonDataTestId={okButtonDataTestId}
      closeButtonDataTestId={closeButtonDataTestId}
      onPrimary={onClose}
      onSecondary={onClose}
      onDismiss={onClose}
    />
  );
}
